<template>
  <v-container>
    <!-- Centra el saludo y la frase inspiradora -->
    <v-row justify="center">
      <v-progress-circular v-if="loadinguserDetails" color="primary" indeterminate></v-progress-circular>
      <v-col v-if="!loadinguserDetails" cols="12" class="text-center">
        <h1 class="mb-3">{{ t('Hola') }} {{ nick }}</h1>
        <div v-if="inspirationalQuote" class="font-italic">{{ inspirationalQuote }}</div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="6" md="4">
        <v-card class="pa-4" @click="clickButton('/scans')">
          <v-card-title >{{ t('Ecografías') }}</v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card class="pa-4" @click="clickButton('/citaciones')">
          <v-card-title >{{ t('Citaciones') }}</v-card-title>
        </v-card>
      </v-col>
      </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';

const userStore = useUserStore();
const router = useRouter();
const { t, locale } = useI18n();

// Variables reactivas
const inspirationalQuote = ref('');
const loadinguserDetails = computed(() => userStore.loadingUserDetails);
const nick               = computed(() => userStore.userDetails?.first_name ?? null);

const clickButton = (path) => {
  router.push(path);
};

// Función para obtener la cita inspiradora
const getInspirationalQuote = async () => {
  try {
    const response = await fetch(`api/get-quote/`);
    const data = await response.json();
    inspirationalQuote.value = data.quote;
  } catch (error) {
    console.error('Error obteniendo la cita:', error);
  } 
};

// Llamar a las funciones cuando el componente se monta
onMounted(() => {
  getInspirationalQuote();
});
// cuando cambie el idioma, volvemos a pedir la cita
watch(() => locale.value, getInspirationalQuote);
</script>